import { useEffect, useState } from "react";
import { Trash2, Download } from "lucide-react";
import { toast } from "sonner";
import { adminSubscribers, adminDeleteSubscriber } from "@/lib/api";
import { AdminHeader, PrimaryBtn } from "./ui";

export default function AdminSubscribers() {
  const [items, setItems] = useState([]);
  const load = () => adminSubscribers().then(setItems);
  useEffect(() => { load(); }, []);

  const remove = async (s) => { if (!window.confirm("¿Eliminar suscriptor?")) return; await adminDeleteSubscriber(s.id); toast.success("Eliminado."); load(); };

  const exportCsv = () => {
    const csv = "email,fecha\n" + items.map((s) => `${s.email},${s.fecha}`).join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = "suscriptores.csv"; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div>
      <AdminHeader title="Newsletter" subtitle={`${items.length} suscriptor(es)`} action={<PrimaryBtn onClick={exportCsv} testId="export-csv"><Download size={15} /> Exportar CSV</PrimaryBtn>} />
      <div className="rounded-xl bg-white border border-[#0f2544]/8 divide-y divide-[#0f2544]/6">
        {items.map((s) => (
          <div key={s.id} className="flex items-center justify-between px-5 py-3" data-testid={`subscriber-row-${s.id}`}>
            <div>
              <div className="text-sm text-[#0f2544]">{s.email}</div>
              <div className="text-xs text-[#8a8a83]">{new Date(s.fecha).toLocaleDateString()}</div>
            </div>
            <button onClick={() => remove(s)} className="p-2 text-[#8a8a83] hover:text-red-600"><Trash2 size={15} /></button>
          </div>
        ))}
        {items.length === 0 && <div className="py-16 text-center text-[#8a8a83]">Sin suscriptores.</div>}
      </div>
    </div>
  );
}
